var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeruFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7638 0.0480875C16.6305 0.0480875 18.479 0.415768 20.2036 1.13014C21.9282 1.8445 23.4953 2.89157 24.8152 4.21155C26.1352 5.53153 27.1823 7.09857 27.8967 8.8232C28.611 10.5478 28.9787 12.3963 28.9787 14.263C28.9787 16.1298 28.611 17.9782 27.8967 19.7028C27.1823 21.4275 26.1352 22.9945 24.8152 24.3145C23.4953 25.6345 21.9282 26.6816 20.2036 27.3959C18.479 28.1103 16.6305 28.478 14.7638 28.478L14.7638 14.263L14.7638 0.0480875Z",
    fill: "#D21F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7636 28.4781C12.8968 28.4781 11.0484 28.1104 9.32375 27.396C7.59912 26.6817 6.03207 25.6346 4.7121 24.3146C3.39212 22.9947 2.34505 21.4276 1.63068 19.703C0.916317 17.9783 0.548637 16.1299 0.548637 14.2632C0.548637 12.3964 0.916317 10.548 1.63069 8.82333C2.34505 7.0987 3.39212 5.53165 4.7121 4.21168C6.03208 2.8917 7.59912 1.84463 9.32376 1.13026C11.0484 0.415897 12.8968 0.0482168 14.7636 0.0482171L14.7636 14.2632L14.7636 28.4781Z",
    fill: "#D21F35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3934 0.819162V27.7072C17.9471 28.2051 16.3953 28.4762 14.7804 28.4781H14.7471C13.1325 28.4762 11.5808 28.2052 10.1348 27.7074V0.818943C11.5858 0.31943 13.1431 0.0482178 14.7638 0.0482178C16.3847 0.0482178 17.9422 0.319509 19.3934 0.819162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeruFlag);
export default __webpack_public_path__ + "static/media/peruFlag.e928c224a0e32f8236a79492f5e6b2d4.svg";
export { ForwardRef as ReactComponent };